<template>
    <div>
        <ContactModal :companyName="contact.companyName" :jobTitle="contact.job_title" @hideModal="hideModal">
            <template v-slot:icon>
                <div class="swal-icon swal-icon--warning">
                    <span class="swal-icon--warning__body">
                        <span class="swal-icon--warning__dot"></span>
                    </span>
                </div>
            </template>
            <template v-slot:content>
                <div class="swal-content mt-4" style="text-align: center;">
                    <div class="content-detail mt-2" v-if="!questionRequest">
                        <h3>{{headerText}}</h3>
                        <p class="mt-2" v-html="infoText" v-if="!refrain"></p>
                        <!-- <p class="mt-2" v-if="!refrain">必要書類の追加提出が必要となる場合があります。<br/>応募後の選考結果などの連絡は、基本的に企業から直接メールで届きます。</p> -->
                    </div>
                    <div class="content-form mt-4">
                        <form @submit.prevent="replyToContact()">
                            <div class="input">
                                <textarea
                                    class="form-control centered-textarea"
                                    rows="4"
                                    name="question"
                                    v-model="question"
                                    data-vv-as="職務要約"
                                    style="height: 100px;background-color: #f4f5f5;"
                                    :placeholder="placeholderText"
                                ></textarea>
                            </div>
                            <div class="content-detail mt-4" v-if="questionRequest">
                                <h3>上記内容で質問しますか？</h3>
                                <p class="mt-2">回答に時間を要する場合や、内容によっては回答を差し控えることがあります。</p>
                            </div>
                            <div class="button-container mt-4">
                                <button class="btn btn-secondary mr-4" @click.prevent="hideModal">
                                    キャンセル
                                </button>
                                <button :class="replyClass" v-html="submitText" type="submit" :disabled="isFormSubmitting">
                                </button>    
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </ContactModal>
    </div>
</template>

<script>
import ContactModal from './ContactModal.vue';
export default {
    name: 'ContactReply',
    props: ['contact','questionRequest','refrain','isFormSubmitting'],
    components: { ContactModal },
    data() {
        return {
            question: '',
            openConfirmationModal: false,
            isQuestionRequest: false,
        }
    },
    computed: {
        userResponse() {
            if ( this.refrain ){
                return '応募見合わせ';
            } else if (this.questionRequest){
                return '質問';
            } else if (this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談';
            } else if (this.contact.contact_type === '面接案内'){
                return '面接参加';
            } else if(this.contact.contact_type === '応募案内') {
                return '選考応募'
            }
        },
        submitText(){
            // console.log(this.contact.contact_type);
            if(this.refrain) {
                return '今回の応募は控える';
            } else if(this.questionRequest) {
                return '質問する';
            } else if(this.contact.contact_type === '面接案内'){
                return '<span><span style="font-size:12px;">選考に応募して</span><br/>面接に参加する</span>'
                // return '選考に応募して\r\n面接に参加する';
            } else if(this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談に参加する';
            } else {
                return '応募する';
            }   
        },
        infoText(){
            const { contact_type } = this.contact;
            // let interviewCommonSentence = '日程調整などの連絡は、基本的に企業から直接メールで届きます。';
            // let applyAndInterviewCommon = '書類の追加提出が必要となる場合があります。';
            if( contact_type === 'カジュアル面談' ){
                return `<span>追加で情報提出が必要な場合もあります。</span>`;
            } else {
                return `<span>マイページへの登録情報をもとに選考が行われます。<br/>（追加で情報提出が必要な場合もあります）</span>`
            }
            // if( type=== 'カジュアル面談' ){
            //     return `<span>書類の追加提出が必要となる場合があります。<br/> ${interviewCommonSentence}</span>`;
            // } else if( type === '応募案内' ) {
            //     return `<span>${applyAndInterviewCommon}<br/>応募後の選考結果などの連絡は、基本的に企業から直接メールで届きます。</span>`;
            // } else {
            //     return `<span>${applyAndInterviewCommon}<br/>${interviewCommonSentence}</span>`;
            // }
        },
        replyClass(){
            // console.log(this.questionRequest)
            if (this.refrain) {
                return 'btn btn-info'
            } else if(this.questionRequest) {
                return 'btn btn-info-blue'
            }else if(this.contact.contact_type === '面接案内') {
                return 'btn btn-info interview';
            } else {
                return 'btn btn-info'
            }
        },
        headerText(){
            if(this.refrain) {
                return '今回の応募は控えますか？'
            }else if(this.contact.contact_type === '応募案内'){
                return '上記に応募しますか?'
            } else if (this.contact.contact_type === 'カジュアル面談') {
                return 'このカジュアル面談に参加しますか?'
            } else if (this.contact.contact_type === '面接案内') {
                return 'この面接に参加しますか?'
            }
        },
        placeholderText(){
            // console.log(this.questionRequest);
            if(this.questionRequest) {
                return '質問をご記入ください'
            } else {
                return '任意記入：企業へ伝えたいメッセージがあればご記入ください'
            }
        }
    },
    methods: {
        hideModal(){
            this.question = ''
            this.$emit('hideModal');
        },
        async replyToContact(){
            try {
                this.$emit('submitForm',{user_response: this.userResponse, user_question: this.question});
                // this.question=''
                // const token = await this.$auth.getToken();
                // const headers = {
                //     Authorization: `Bearer ${token}`,
                // };
                // const contact = await this.axios({
                //     method: 'put',
                //     url: Api.url(Api.endpoints.reply),
                //     headers: headers,
                //     data: {
                //         question: this.question
                //     }
                // });   
                // if(contact) {
                    // this.openConfirmationModal = true;
                    // this.hideModal();
                // }
                // console.log(contact.data);
            } catch (err){
                console.log(err);
            } 
        }
    },
    mounted(){
        // console.log(this.contact);
        // this.$refs.contactModal.show();
    }
}
</script>

<style scoped>
>>> .modal-body {
    padding: 0px !important
}

.btn-info {
    background-color: #006C6B;
    width: 280px;
    /* padding-left: 30px; */
}

.btn-info.interview {
    padding: 0px;
}

.btn-secondary {
    width: 280px;
}

.btn-info-blue {
    background-color: #2F80ED;
    color: #fff;
    width: 280px;
}

.btn {
    border-radius: 4px;
    font-weight: bold;
}
h3{
    font-weight: bold;
    font-size: 20px;
}

.swal-icon:first-child {
    margin-top: 32px;
}

.swal-icon {
    width: 80px;
    height: 80px;
    border-width: 4px;
    border-style: solid;
    border-radius: 50%;
    padding: 0;
    position: relative;
    box-sizing: content-box;
    margin: 20px auto;
}

.swal-icon--warning {
    border-color: #f8bb86;
    -webkit-animation: pulseWarning .75s infinite alternate;
    animation: pulseWarning .75s infinite alternate;
}

.swal-icon--warning__body, .swal-icon--warning__dot {
    position: absolute;
    left: 50%;
    background-color: #f8bb86;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-left: -4px;
    bottom: -11px;
}

.swal-icon--warning__body {
    width: 5px;
    height: 47px;
    top: 10px;
    border-radius: 2px;
    margin-left: -2px;
}

@media(max-width: 767px) {
    .btn-secondary {
        width: 45%;
        height: 50px;
        font-size: 12px;
    }
    .btn-info,
    .btn-info-blue {
        width: 45%;
        height: 50px;
        padding: 2px;
        font-size: 12px;
        white-space: pre-line;
    }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    .btn-secondary {
        width: 45%;
        height: 50px;
        font-size: 14px;
    }
    .btn-info,
    .btn-info-blue {
        width: 45%;
        height: 50px;
        padding: 8px;
        font-size: 14px;
    }

}


</style>